var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } } return target; }
import * as React from "react";
function SvgAlcoholAndDrugActivity(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "a",
    d: "M0 29.996V0h30v29.996z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("mask", {
    id: "b",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#a"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#91CA9D",
    d: "M15 0c8.284 0 15 6.716 15 15 0 8.284-6.716 15-15 15-8.284 0-15-6.716-15-15C0 6.716 6.716 0 15 0",
    mask: "url(#b)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#309079",
    d: "M2.97 23.958A14.975 14.975 0 0 0 15 30c4.923 0 9.298-2.375 12.03-6.042H2.97",
    mask: "url(#b)"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#E6E9EA",
    d: "M18.548 23.524a1.03 1.03 0 0 0 .613-.94v-3.548c0-.31-.155-.584-.393-.78a.619.619 0 0 1-.238-.47c0-.316.268-.578.63-.661v-.238h.465v.238c.363.083.631.345.631.66a.6.6 0 0 1-.238.471 1.023 1.023 0 0 0-.393.78v3.547c0 .411.244.78.613.94l.976.43h-3.643l.977-.43"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M22.327 10.315a9.066 9.066 0 0 1 .661 3.334c0 2.893-1.607 4.315-3.595 4.315-1.988 0-3.595-1.422-3.595-4.315 0-1.125.244-2.31.66-3.334h5.87"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E36A57",
    d: "M22.631 12.72c.048.351.071.697.071 1.042 0 2.482-1.267 4.024-3.303 4.024s-3.304-1.542-3.304-4.024c0-.34.024-.69.072-1.042h6.464"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#DF5040",
    d: "M20.798 16.756l.053-.054c.042-.041.095-.095.16-.172.066-.078.144-.173.227-.286.083-.113.167-.244.244-.393.16-.297.31-.66.405-1.065.048-.203.083-.411.113-.625.024-.22.042-.429.042-.655a6.779 6.779 0 0 0-.03-.78h-.316c.048.256.078.518.09.786a7.6 7.6 0 0 1 .006.637c-.012.208-.03.416-.066.613a4.192 4.192 0 0 1-.315 1.06 5.014 5.014 0 0 1-.215.404 2.987 2.987 0 0 1-.202.292c-.06.083-.113.143-.149.178-.024.03-.041.048-.047.06"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E6E9EA",
    d: "M21.399 10.315h-.542c.024.048.06.108.095.179.09.167.203.417.322.714.166.417.327.947.422 1.512h.316a8.044 8.044 0 0 0-.601-2.38c-.006-.013-.006-.019-.012-.025"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E36A57",
    d: "M9.66 5.41h1.971l.375-1.386h-2.72L9.66 5.41"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#2F424F",
    d: "M9.56 8.22V5.69h2.166v2.53c0 .554.286 1.06.762 1.345a3.563 3.563 0 0 1 1.72 3.048v10.488a.823.823 0 0 1-.821.822H7.899a.823.823 0 0 1-.822-.822V12.613c0-1.292.69-2.423 1.72-3.048.477-.285.763-.797.763-1.345"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#CBD2D7",
    d: "M9.333 5.899h2.62c.03 0 .047-.024.047-.048v-.56a.047.047 0 0 0-.048-.047H9.333a.047.047 0 0 0-.047.048v.56c0 .023.018.047.047.047"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FACC5F",
    d: "M7.083 20.315H12.9v-6.541H7.083z"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAlcoholAndDrugActivity);
export default __webpack_public_path__ + "static/media/alcohol-and-drug-activity.1463855528465dc1140c22044f218702.svg";
export { ForwardRef as ReactComponent };